module.exports = __webpack_public_path__ + "static/media/f2.33d31ba1.jpg";